import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const TestimonialsPageSession = React.lazy(() => import('../testimonials/TestimonialsPageSession'));
const TestimonialsPageHeader = React.lazy(() => import('../testimonials/TestimonialsPageHeader'));

function TestimonialsPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <TestimonialsPageHeader />
       <TestimonialsPageSession />
      </Suspense>
    </div>
  );
}

export default TestimonialsPage;
